// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"62":"calendar-event","453":"calendar-create-event","625":"calendar-event-report","946":"y-collab-core-v7"}[chunkId] || chunkId) + ".chunk.bundle.js";
};